import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

// =============================================================================
// Stats Grid Animations
// =============================================================================
export function statsGridAnimations() {
  const statItems = document.querySelectorAll('.stats-grid__item')
  
  if (statItems.length === 0) return

  // Animation can be added here when needed
  // gsap.to(statItems, {
  //   scale: 1,
  //   opacity: 1,
  //   duration: 0.6,
  //   delay: 2,
  //   stagger: 0.1,
  //   ease: 'back.out(1.7)',
  //   scrollTrigger: {
  //     trigger: '.stats-grid',
  //     start: 'top 50%',
  //     toggleActions: 'play none none none'
  //   }
  // })
}

